export default __webpack_public_path__ + "static/media/crc-block-ip-color.4ed46529.svg";